import * as React from 'react';
import { RefreshControl, StyleSheet, LayoutAnimation } from 'react-native';
import { Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Spinner, InputGroup, Input, Item, View } from 'native-base';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import XDate from 'xdate';
import PopupMenu from './popupMenu';
import Alert from './alert';
import { poundMinus, truncateOnWord } from './globals';

const FakeItem = ({ i }) => (
	<View key={i}>
		<ListItem itemDivider>
			<ShimmerPlaceHolder autoRun width={95} height={18.7} />
		</ListItem>
		<ListItem avatar>
			<Left style={{ flexDirection: 'column', marginRight: 5 }}>
				<PopupMenu actions={['Not loaded!']} style={{ color: 'grey', padding: 0, paddingHorizontal: 8, marginTop: -5 }} onPress={(e, i) => {}} />
				<Icon name="log-in" style={{ fontSize: 22, color: '#AAA' }} />
			</Left>
			<Body>
				<ShimmerPlaceHolder autoRun width={230} height={19} />
				<View style={{ flexDirection: 'row', marginTop: 5, alignContent: 'space-around', width: '100%' }}>
					<ShimmerPlaceHolder autoRun width={100} height={20} />
					<ShimmerPlaceHolder autoRun width={100} height={20} />
				</View>
			</Body>
			<Right>
				<ShimmerPlaceHolder autoRun width={30} style={{ margin: 2 }} />
				<ShimmerPlaceHolder autoRun width={30} style={{ margin: 2 }} />
			</Right>
		</ListItem>
	</View>
);

class RecentTransList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			searching: false,
			refreshing: false
		};
	}

	_dropSelect(item, i) {
		if (i == 0) return this.props.onSelectTrans(item); //edit
		if (i == 1) return this.props.onCopyTrans(item); //copy
		if (i == 2) {
			if (!!item.invoice_id && item.invoice_status != 'draft' && item.net > 0) return Alert.alert('Cannot void sent invoice', 'You will need to issue a credit note to reverse this invoice.');
			return Alert.alert(
				'Delete ' + item.transaction_type,
				'Permanently delete this entry?',
				[
					{ text: 'Cancel', onPress: () => console.log('Cancel Pressed'), style: 'cancel' },
					{ text: 'OK', onPress: () => this.props.onDeleteTrans(item) }
				],
				{ cancelable: true }
			);
		}
	}

	render() {
		const that = this;
		const { loading, list, onSelectTrans } = this.props;
		//console.log(list);
		if (!list)
			return (
				<View style={{ flex: 1 }}>
					<FakeItem i={0} />
					<FakeItem i={1} />
					<FakeItem i={2} />
				</View>
			);
		//LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut); //crashes
		//console.log('list', this.props.list);
		return (
			<View style={{ flex: 1 }}>
				{!!list &&
					typeof list == 'object' &&
					!list.status &&
					list.length > 0 &&
					list.map(function (item, i, arr) {
						var invoice = !!item.invoice_id;
						var datehead = i == 0 || item.expenseDate != arr[i - 1].expenseDate;
						var bal = item.paid - item.payable;
						const colourpos = item.transaction_type == 'receipt' ? 'green' : 'darkred';
						const colourneg = item.transaction_type == 'receipt' ? 'darkred' : 'green';
						var balcolour = bal == 0 ? 'black' : bal > 0 ? 'green' : 'darkred';
						//bal = bal<0? '-£'+(0-bal).toFixed(2) : '+£'+bal.toFixed(2);
						var amtcolour = item.payable == 0 ? '#AAA' : item.payable > 0 ? colourpos : colourneg;
						var paidcolour = item.paid == 0 ? '#AAA' : item.paid > 0 ? colourpos : colourneg;
						var colour, icon;

						if (!invoice) {
							colour = item.paid > item.payable ? 'green' : 'black';
							icon = 'log-in';
						} else {
							icon = item.payable >= 0 ? 'list-box' : 'undo';
							if (item.invoice_status == 'void') colour = amtcolour = paidcolour = balcolour = '#EEE';
							if (item.invoice_status == 'draft') colour = 'grey';
							if (item.invoice_status == 'sent') colour = '#9b59b6';
							if (item.invoice_status == 'overdue') colour = '#dd2946';
						}
						const invoice_status = item.invoice_status == 'draft' ? 'open' : item.invoice_status;

						var recpay = item.supplier_id ? 'Paid' : 'Received';
						const expenseDate = XDate().diffDays(XDate(item.expenseDate)) == 0 ? 'Today' : XDate(item.expenseDate).toString('ddd dd/MM/yy');

						return (
							<View key={i}>
								{datehead ? (
									<ListItem itemDivider>
										<Text>{expenseDate}</Text>
									</ListItem>
								) : null}

								<ListItem avatar onPress={() => onSelectTrans(item)}>
									<Left style={{ flexDirection: 'column', marginRight: 5 }}>
										{item.id > 0 && item.invoice_status != 'void' && (
											<PopupMenu
												actions={['Edit', 'Copy', invoice ? 'Void' : 'Delete']}
												style={{ color: 'grey', padding: 0, paddingHorizontal: 8, marginTop: -5 }}
												onPress={(e, i) => that._dropSelect(item, i)}
												destructiveButtonIndex={2}
											/>
										)}
										<Icon name={icon} style={{ fontSize: 22, color: colour }} />
									</Left>
									<Body>
										<Text style={{ color: colour }}>{truncateOnWord(item.description)}</Text>

										<View style={{ flexDirection: 'row' }}>
											<Text note style={[styles.row, { color: amtcolour }]}>
												Amount{'\n'} {poundMinus(item.payable)}
											</Text>

											<Text note style={[styles.row, { color: paidcolour }]}>
												{recpay} {'\n'}
												{poundMinus(item.paid)}
											</Text>
										</View>
									</Body>
									<Right>
										<Text note style={invoice ? { color: colour } : {}}>
											{invoice ? invoice_status : 'Balance'}
										</Text>
										<Text style={{ color: balcolour }}>{poundMinus(bal)}</Text>
									</Right>
								</ListItem>
							</View>
						);
					})}
			</View>
		);
	}
}

const styles = StyleSheet.create({
	container: {
		backgroundColor: '#FBFAFA',
		flex: 1
	},
	flex1: {
		flex: 1
	},
	row: {
		flex: 1,
		alignItems: 'center'
	},
	text: {
		fontSize: 20,
		marginBottom: 15,
		alignItems: 'center'
	},
	mt: {
		marginTop: 18
	}
});

export default RecentTransList;
